import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { LABEL_FRAGMENT } from './label'

import type { AbTestsParametersSchemaDTO } from 'features/ab-tests/api/types/abTestsParametersSchemaDTO'

export const GENERAL_FRAGMENT: TypedDocumentNode<AbTestsParametersSchemaDTO['general']> = gql`
  ${LABEL_FRAGMENT}

  fragment generalFragment on AbTestsParametersGeneral {
    customCode {
      ...labelFragment
    }
    label
  }
`
